export default __webpack_public_path__ + "static/media/architecture-img-19.cc58c1de.jpg";